/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getShiftCovers} from '../api'

 export const useQueryGetShiftCovers = createReactQueryHook('getShiftCovers', getShiftCovers)
